module.exports = __webpack_public_path__ + "static/img/cybercrime_4.a7ef634b.png";